import axios from "axios";
export default {
  report: (id, cancelToken) => axios.get(`/api/expenses/${id}/report`, { cancelToken, responseType: "blob" }),
  reporteDoc: (id, cancelToken) => axios.get(`/api/expenses/${id}/reporteDoc`, { cancelToken, responseType: "blob" }),
  allExpensesReport: (params, cancelToken) =>
    axios.get(`/api/expenses/export/all`, { cancelToken, params, responseType: "blob" }),
};
